import DefaultImage from "../../../assets/images/default-avatar-photo-placeholder-profile-picture-vector.jpg";
import ReneSoriano from "../../../assets/images/directors/rene-soriano.png";
import ReynatoPrimo from "../../../assets/images/directors/reynato-primo.png";

const RPTC = () => {
  return (
    <div id='chartListContainer'>
      <ul className='main-list'>
        <li className='list-item main'>
          <div className='image-container'>
            <img src={DefaultImage} alt='' />
          </div>
          <div className='text-container'>
            <div className='name'>[Vacant Position]</div>
            <div className='title'>Chairman</div>
          </div>
        </li>
      </ul>
      <ul className='sub-list'>
        <li className='list-item'>
          <div className='image-container'>
            <img src={ReneSoriano} alt='rene-soriano' />
          </div>
          <div className='text-container'>
            <div className='name'>Rene Y. Soriano</div>
            <div className='title'>Member</div>
          </div>
        </li>
        <li className='list-item'>
          <div className='image-container'>
            <img src={ReynatoPrimo} alt='reynato-primo' />
          </div>
          <div className='text-container'>
            <div className='name'>Reynato J. Primo</div>
            <div className='title'>Member</div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default RPTC;
